



























import Vue from 'vue'
import restaurants from '@/services/Restaurants'
import auth from '@/firebaseApp'
import 'firebase/functions'
import firebaseApp from '@/firebaseApp'

export default Vue.extend({
  name: 'NewRestaurant',
  data() {
    return {
      restaurant: {
        name: '',
        emailOwner: '',
      },
    }
  },
  methods: {
    async createUser(restaurantId: string, email: string) {
      const addUser = firebaseApp.functions('europe-west1').httpsCallable('addUser')
      const continueUrl = `${window.config.baseUrl}/${restaurantId}/owner`
      const result = await addUser({ email, role: 'owners', restaurantId })

      if (result?.data?.uid) {
        await auth.auth().sendPasswordResetEmail(email, {
          url: continueUrl,
        })
      }
    },
    async addRestaurant() {
      const name = this.restaurant.name
      if (!name) {
        alert(this.$i18n.t('admin.restaurants.alertName'))
        return
      }

      const id = restaurants.nameToId(name)
      const success = await restaurants.create(id, name)
      if (!success) {
        alert(
          this.$i18n.t('admin.restaurants.alertDuplicate', {
            id,
            name,
          })
        )
        return
      }

      try {
        await this.createUser(id, this.restaurant.emailOwner)
      } catch (err) {
        console.error('Error while creating user', err)
        alert(this.$i18n.t('admin.restaurants.alertOwner'))
        return
      }

      this.restaurant = {
        name: '',
        emailOwner: '',
      }
    },
  },
  computed: {
    isFormValid() {
      return (
        this.restaurant.name &&
        this.restaurant.emailOwner &&
        this.restaurant.emailOwner.indexOf('@') !== -1
      )
    },
  },
})
